/**
 * Haptic feedback utility — uses Vibration API on supported devices.
 * Falls back silently on unsupported devices.
 */

const canVibrate = typeof navigator !== "undefined" && "vibrate" in navigator;

/** Light tap — button press, toggle */
export function hapticLight() {
  if (canVibrate) navigator.vibrate(10);
}

/** Medium tap — set completion, meal logged */
export function hapticMedium() {
  if (canVibrate) navigator.vibrate(25);
}

/** Strong tap — PR hit, workout complete */
export function hapticStrong() {
  if (canVibrate) navigator.vibrate([30, 50, 30]);
}

/** Success pattern — double tap for celebrations */
export function hapticSuccess() {
  if (canVibrate) navigator.vibrate([15, 80, 15, 80, 30]);
}

/** Warning pattern — streak danger */
export function hapticWarning() {
  if (canVibrate) navigator.vibrate([40, 100, 40]);
}
